import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useQueryPayer } from "../../../query/payers/queries/useQueryPayer";
import { getPayerName } from "../../Payers/utils/getPayerNames";

type Props = {
  payerId: string;
};

export const LabelPayerName: React.FC<Props> = props => {
  const payerQuery = useQueryPayer(props.payerId);

  const name = useMemo(() => {
    if (!payerQuery.data) {
      return;
    }

    return getPayerName(payerQuery.data);
  }, [payerQuery.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox gap="XS" wrap="nowrap" alignItems="center">
      <WSIcon name="user" color="gray600" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
